import { useNavigate, useParams } from 'react-router-dom';

import {
  GoAButton,
  GoAFormItem,
  GoAIcon,
  GoAInputEmail,
  GoAModal,
} from '@abgov/react-components';
import { createRef, useRef, useState } from 'react';
import React from 'react';
import { Email } from '../models/email';
import useCsrService from '../services/csr-api-redux';
import { AppDispatch } from '../state/store';
import { useDispatch } from 'react-redux';
import { emailUserInformation } from '../state/slices/authSlice';

export interface EmailRouteProps {}

export const EmailComponent = ({}: EmailRouteProps) => {
  const dispatch = useDispatch<AppDispatch>();

  let navigate = useNavigate();
  const csrService = useCsrService();

  const sendRef = createRef<HTMLDivElement>();
  const [showIntro, setShowIntro] = useState(true);
  const [shwoConfirmed, setShowConfirmed] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);

  const [emailErrorText, setEmailErrorText] = useState('');
  const [email, setEmail] = useState<Email>();

  const { id } = useParams();

  const handleTabToSend = () => {
    if (sendRef.current) {
      sendRef.current.focus();
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSendClick();
    }
  };

  const handleSendClick = () => {
    if (email && email.isValid()) {
      const emailRequest = {
        email_address: email.toString(),
        collision_id: id,
      };
      dispatch(emailUserInformation({ csrService, emailRequest }))
        .then((response) => {
          setShowEmailModal(false);
        })
        .catch((error) => {
          setEmailErrorText('Error sending email');
        });
      setEmailErrorText('');
    } else {
      setEmailErrorText('Provide a valid email');
    }
  };

  const navigateToCollision = () => {
    navigate('/collision', { state: true });
  };

  return (
    <main>
      <div style={{ display: showIntro ? 'block' : 'none' }}>
        <h2>Here is your guest collision ID number</h2>

        <h2>{id}</h2>

        <div>
          Before starting a new report, save your collision ID number via email.
        </div>
        <br />
        <div>
          Registering for a verified account can take up to 10 days; but you can
          start, save or update your report later by accessing your saved
          collision ID number. You will need to enter this number to log back
          into Report My Collision.
        </div>
        <br />
        <div>
          <GoAButton
            type="tertiary"
            onClick={() => {
              setShowEmailModal(true);
            }}
          >
            Email me the collision ID <GoAIcon type="mail"></GoAIcon>
          </GoAButton>
        </div>
        <br />
        <div>
          <GoAButton
            type="start"
            onClick={() => {
              navigateToCollision();
            }}
          >
            Start my report
          </GoAButton>
        </div>
      </div>
      <div>
        <GoAModal open={showEmailModal}>
          <div>
            <h3>Email me the ID code</h3>
          </div>
          <div>
            Sit voluptas voluptatem ut neque accusantium aut voluptate earum et
            quia officia
          </div>
          <br />
          <div>{id}</div>
          <br />
          <div>
            <GoAFormItem
              error={emailErrorText}
              label="Enter a valid email address"
            >
              <GoAInputEmail
                error={emailErrorText.length > 0}
                name="email"
                onChange={(item, value) => {
                  const email = new Email(value);
                  setEmail(email);
                }}
                onBlur={() => handleTabToSend()}
                trailingContent={React.createElement(
                  'div',
                  {
                    ref: sendRef,
                    tabIndex: 0,
                    onClick: handleSendClick,
                    onKeyDown: handleKeyDown,
                    style: {
                      cursor: 'pointer',
                    },
                  },
                  'Send',
                )}
                onTrailingIconClick={() => {
                  if (email && email.isValid()) {
                    setShowEmailModal(false);
                    setShowIntro(false);
                    setShowConfirmed(true);
                  }
                }}
              />
            </GoAFormItem>
          </div>
          <div>
            <GoAButton
              type="tertiary"
              onClick={() => {
                setShowEmailModal(false);
              }}
            >
              Cancel
            </GoAButton>
          </div>
          <div>
            Diclaimer text Sit voluptas voluptatem ut neque accusantium aut
            voluptate earum et quia officia
          </div>
        </GoAModal>
      </div>
      <div style={{ display: shwoConfirmed ? 'block' : 'none' }}>
        <h2>Confirmed</h2>
        <div>
          We have emailed your collision ID number {id} to the email below.
        </div>
        <br />
        <div>{email?.toString()}</div>
        <br />
        <div>
          While you wait to receive your verified account, continue to use your
          guest collion number ID to log back into Report My Collision at any
          time.
        </div>
        <br />
        <GoAButton
          type="start"
          onClick={() => {
            navigateToCollision();
          }}
        >
          Start My Report
        </GoAButton>
      </div>
    </main>
  );
};
